module.exports = __webpack_public_path__ + "img/tank-base-shadow-2.4effa54d.png";